export const CHANGE_PAGE_ACTION = "CHANGE_PAGE_ACTION";

export const changePageAction = ( newPage ) =>({
    type: CHANGE_PAGE_ACTION,
    payload: newPage
});